module.exports = __webpack_public_path__ + "img/f-tr.94e8140a.png";